import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';
import { Input } from '../../../components/core/Input';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { getTokensLocalStorage } from '../../../utils/auth/getTokensLocalStorage';
import Select from '../../../components/others/Select/Select';
import LavorisService from '../../../services/LavorisService';
import { DATAJSON } from './json/updateCompany';
import StyledWrapper from './style';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/combineReducer';
import { CircularProgress } from '@mui/material';
import Textarea from '../../../components/others/Textarea/Textarea';
import { useAlert } from '../../../hooks/useAlert';
import { getErrorMessage } from '../../../utils';

export default function EditCompany() {
  //useState
  const [branchData, setBranchData] = useState<any>([]);
  const [isReady, setReady] = useState(false);
  const [ivaConditionsValues, setivaConditionsValues] = useState<any>([]);
  const [rubroCompanyValues, setrubroCompanyValues] = useState<any>([]);
  const [artsCompanyValues, setArtsCompanyValues] = useState<any>([]);

  //useSearchParams
  const [searchParams, setSearchParams] = useSearchParams('');

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'all'
  });

  const LavorisInstance = LavorisService.getInstance();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false)
  const { name, email, companies } = useSelector(
    (state: RootState) => state.user
  );

  // useEffects
  const dataPublic = async () => {
    try {
      const publicData = await LavorisInstance.PublicData.getPublicData();
      if (publicData) {
        setrubroCompanyValues(publicData.rubroCompany);
        setivaConditionsValues(publicData.ivaConditions);
        setArtsCompanyValues(publicData.arts);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const getCompanyProfile = async () => {
    try {
      const companyID = companies[0].id;
      const companyProfile: any =
        await LavorisInstance.CompanyServices.getCompanyProfile(companyID);
      if (companyProfile) {
        setBranchData(companyProfile);
        reset({ ...companyProfile });
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await dataPublic();
      await getCompanyProfile();
      setReady(true);
    };
    fetchData();
  }, [searchParams, useParams]);

  const handleClose = () => {
    document.getElementById('modal-overlay-modalEditarEmpresa')?.click();
  };

  const onSubmit = async (data: any) => {
    try {
      setIsLoading(true)
      const response: any = await LavorisInstance.CompanyServices.updateCompany(
        data
      );
      if (response === '') {
        handleClose();
      }
    } catch (err: any) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al editar la compañia', err }));
    }
    finally{
      setIsLoading(false)
    }
  };

  if (!isReady) return <CircularProgress color="error" size={15} />;

  return (
    <div className="w-full h-full">
      {/*<button
        className="w-full h-40 bg-neutral-100 rounded-lg flex items-center justify-center mt-12"
        onClick={() => {}}
      >
        <div className="w-32 h-32 bg-white flex items-center justify-center rounded-full relative">
          <img src="/images/LogoFuzzy.svg" alt="" />
          <div className="absolute bottom-0 right-0">
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="17" cy="17" r="17" fill="#C6C6C6" />
              <path
                d="M12.5 21.5L16.5719 21.4861L25.4593 12.6253C25.8081 12.2742 26 11.808 26 11.312C26 10.816 25.8081 10.3497 25.4593 9.99866L23.9959 8.52559C23.2983 7.82341 22.0813 7.82713 21.3893 8.5228L12.5 17.3854V21.5ZM22.6912 9.83891L24.1574 11.3092L22.6838 12.7786L21.2204 11.3064L22.6912 9.83891ZM14.3454 18.16L19.9093 12.6123L21.3727 14.0854L15.8097 19.6313L14.3454 19.6359V18.16Z"
                fill="white"
              />
              <path
                d="M10.8333 25H23.6667C24.6778 25 25.5 24.1778 25.5 23.1667V15.221L23.6667 17.0543V23.1667H13.7282C13.7043 23.1667 13.6796 23.1758 13.6558 23.1758C13.6255 23.1758 13.5953 23.1676 13.5641 23.1667H10.8333V10.3333H17.1098L18.9431 8.5H10.8333C9.82225 8.5 9 9.32225 9 10.3333V23.1667C9 24.1778 9.82225 25 10.8333 25Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
  </button>*/}

      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>
          {DATAJSON.map((obj: any, index: number) => (
            <>
              {obj.type === 'text' ? (
                <Input
                  key={index}
                  type="text"
                  label={obj.label || ''}
                  fieldName={obj.fieldName}
                  register={register}
                  required={obj.required ? true : false}
                  error={errors?.[obj.fieldName]}
                  readOnly={obj.readOnly}
                />
              ) : null}
              {obj.type === 'select' ? (
                <Select
                  key={index}
                  fieldName={obj.fieldName}
                  label={obj.label}
                  register={register}
                  required={obj.required ? true : false}
                  error={errors?.[obj.fieldName]}
                  options={
                    obj.fieldName === 'ivaCondition'
                      ? ivaConditionsValues
                      : obj.fieldName === 'heading'
                      ? rubroCompanyValues
                      : obj.fieldName === 'ART'
                      ? artsCompanyValues
                      : [{ name: '', value: '' }]
                  }
                  styles="rounded w-full h-[50px]"
                />
              ) : null}
              {}
              {obj.type === 'tittle' ? (
                <StyledWrapper.Tittle>{obj.label}</StyledWrapper.Tittle>
              ) : null}
              {obj.type === 'subtittle' ? (
                <StyledWrapper.SubTittle>{obj.label}</StyledWrapper.SubTittle>
              ) : null}
              {obj.type === 'normalText' ? (
                <p key={index}>{obj.label}</p>
              ) : null}
            </>
          ))}
          <Textarea
            register={register}
            fieldName="comment"
            label="Comentarios"
            error={errors.comment}
            rows={4}
            styles="rounded w-full"
          />
          <div className="flex gap-6">
            <PrimaryButton
              type="button"
              onClick={() => {
                handleClose();
              }}
              text="Cancelar"
              styles="bg-white font-bold text-red-500 mt-8 border-red-500 border"
            />
            <PrimaryButton
              type="submit"
              text="Guardar cambios"
              styles="bg-red-500 font-bold text-white mt-8"
              loading={isLoading}
            />
          </div>
        </StyledWrapper.FormContainer>
      </form>
    </div>
  );
}
